module.exports = __webpack_public_path__ + "static/media/doubleQuoteFront.19f71b89.svg";